import { ICoverageServerStoreSegment } from './coverageServer.interface';

export const coverageServerStoreSelector = (state: ICoverageServerStoreSegment) => state.coverageServer;
